import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const LINKEDIN_URL = "https://www.linkedin.com/company/joy-resume-builders";

export default function Footer() {
  return (
    <footer className="relative bg-navy text-white grain overflow-hidden" data-testid="site-footer">
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
          <div>
            <div className="flex items-center gap-2 mb-5">
              <span className="w-9 h-9 bg-white text-navy grid place-items-center font-display text-xl leading-none">J</span>
              <span className="font-display text-xl font-bold">Joy Resume Builders<span className="text-cobalt-light">.</span></span>
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed">
              Executive resume writing, LinkedIn optimization and career consulting for technical & professional talent.
            </p>
            <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin"
              className="mt-6 inline-flex items-center gap-2 border border-white/20 hover:border-cobalt-light hover:bg-white/5 transition-colors px-4 py-2.5 text-sm text-white/85">
              <Linkedin size={16} className="text-cobalt-light" /> Follow us on LinkedIn
            </a>
          </div>
          <div>
            <p className="overline text-cobalt-light mb-4">Explore</p>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/jobs" className="hover:text-white transition-colors">Job Opportunities</Link></li>
              <li><Link to="/resume-review" className="hover:text-white transition-colors">AI Resume Review</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Client Portal</Link></li>
              <li><a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">LinkedIn</a></li>
            </ul>
          </div>
          <div>
            <p className="overline text-cobalt-light mb-4">Contact</p>
            <ul className="space-y-3 text-white/70">
              <li>joy.resumebuilder@gmail.com</li>
              <li>+91 88850 01332</li>
              <li>Bengaluru · Remote worldwide</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-white/40 text-sm">
          <span>© {new Date().getFullYear()} Joy Resume Builders & Consulting. All rights reserved.</span>
          <span className="font-mono-ui text-xs">CRAFTED FOR CAREERS THAT MATTER</span>
        </div>
      </div>
    </footer>
  );
}
